import { Box } from '@mui/material';
import { Button, useDataProvider, useRefresh, useNotify, useRecordContext, Confirm } from 'react-admin';
import { useState } from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import { IntegrationStatus } from '../Pages/Hcm/HcmEdit';

const StartStopIntegrationButton: React.FC = () => {
  const record = useRecordContext();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const notify = useNotify();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingAction, setPendingAction] = useState<{ status: IntegrationStatus; label: string } | null>(null);

  if (!record) return null;

  const handleStatusChange = async (newStatus: IntegrationStatus) => {
    try {
      await (dataProvider as any).updateIntegrationStatus(record.uuid, newStatus);
      refresh();
      notify(`Integration ${newStatus.toLowerCase()} successfully`, { type: 'success' });
    } catch (error) {
      notify(`Failed to ${newStatus.toLowerCase()} integration`, { type: 'error' });
    }
  };

  const openConfirmDialog = (status: IntegrationStatus, label: string) => {
    setPendingAction({ status, label });
    setConfirmOpen(true);
  };

  const handleConfirm = () => {
    if (pendingAction) {
      handleStatusChange(pendingAction.status);
    }
    setConfirmOpen(false);
    setPendingAction(null);
  };

  const handleCancel = () => {
    setConfirmOpen(false);
    setPendingAction(null);
  };

  const isRunning = record.status === IntegrationStatus.STARTED;
  const isPaused = record.status === IntegrationStatus.PAUSED;

  return (
    <>
      <Box sx={{ display: 'flex', gap: 1 }}>
        {isPaused && (
          <Button
            label="Start"
            onClick={(e) => {
              e.stopPropagation();
              openConfirmDialog(IntegrationStatus.STARTED, 'start');
            }}
            size="small"
            color="primary"
          >
            <PlayArrowIcon />
          </Button>
        )}
        {isRunning && (
          <Button
            label="Pause"
            onClick={(e) => {
              e.stopPropagation();
              openConfirmDialog(IntegrationStatus.PAUSED, 'pause');
            }}
            size="small"
            color="secondary"
          >
            <StopIcon />
          </Button>
        )}
      </Box>
      <Confirm isOpen={confirmOpen} title={`Confirm ${pendingAction?.label || 'action'}`} content={`Are you sure you want to ${pendingAction?.label || 'perform this action on'} this integration (${record.uuid})?`} onConfirm={handleConfirm} onClose={handleCancel} />
    </>
  );
};

export default StartStopIntegrationButton;
